import React, { PureComponent } from 'react';
import { message } from 'antd';
import { services } from '@comall-backend-builder/core';
import { DesignPage } from '../../design_page';
import { DESIGN_PAGE_LINK_TYPES_LIST } from '../../constants/page-design';
import { errorHandle } from '../../services';
const api = services.api;
/**
 * 可视化--页面设计
 */
export class PageDesign extends PureComponent<any> {
    loadProfile = () => {
        const {
            params: { id },
        } = this.props;
        return api.get({ id }, { apiPath: '/page/:id' }).catch(errorHandle);
    };
    onSave = (data: any) => {
        api.put(data, { apiPath: '/page/:id' })
            .then(() => {
                message.success('保存成功');
                services.navigation.goBack();
            })
            .catch(errorHandle);
    };
    onUpdate = async (data: any) => {
        console.log('data是什么', data, JSON.parse(data.config));
        let config = JSON.parse(data.config);
        const type = 'FK_POINTS'; // 积分商品类型
        let skuArr = ''; // 存储原来的积分商品skus
        let components = JSON.parse(data.config).components;
        let pointProductList = []; // 存储配置的积分商品的数组，此为对象数组，key为区域的pointProducts-id value为对应的商品数组
        // 过滤出积分商品（组件类型为积分商品，showStyle=3 ，且entry不为空）
        for (let item in components) {
            if (
                item.indexOf('pointProducts') > -1 &&
                components[item].showStyle &&
                components[item].showStyle == '3' &&
                components[item].entry &&
                components[item].entry.length
            ) {
                let obj = {};
                obj[item] = components[item].entry;
                pointProductList.push(obj);
            }
        }
        console.log('pointProductList找出来的是啥', pointProductList);
        if (pointProductList.length) {
            // 拼接skus
            pointProductList.forEach((item) => {
                for (let innerItem in item) {
                    item[innerItem].forEach((lastItem) => {
                        skuArr += lastItem.sku + ',';
                    });
                }
            });
            skuArr = skuArr.slice(0, -1);
            console.log(skuArr);
            let skuArrList = skuArr.split(',');
            let results = []; // 用于存放最新的对应商品信息得商品数组
            let n = 20; // 多少个为一组得步长
            // 将skuarr分为20个为一组，遍历请求接口，防止数据量多时造成接口超时报错
            for (let i = 0; i < Math.ceil(skuArrList.length / n); i++) {
                // 用原来的skus换取最新的对应商品信息
                let first = await this.getskuListBySkus(
                    type,
                    skuArrList.slice(i * n, i * n + n).join()
                );
                results = results.concat(first);
            }
            console.log(results);
            if (results.length === skuArrList.length) {
                // 循环便利后将拿到得所有商品信息进行  重新赋值给对应组件区域(res.result返回的对应的可能是多个积分商品区域，需要通过res.result中的每个项的sku进行比对，再填充到对应区域的entry中)
                for (let item in components) {
                    pointProductList.forEach((pointItem) => {
                        for (let innerItem in pointItem) {
                            if (innerItem === item) {
                                let sameComponentEntry = [];
                                let originComponemtEntry = components[item].entry;
                                originComponemtEntry.forEach((origin) => {
                                    results.forEach((resultItem) => {
                                        if (origin.sku === resultItem.sku) {
                                            sameComponentEntry.push(resultItem);
                                        }
                                    });
                                });
                                components[item].entry = sameComponentEntry;
                            }
                        }
                    });
                }
                config.components = components;
                data.config = JSON.stringify(config);
                // 将重新组装的页面数据保存，并刷新页面
                api.put(data, { apiPath: '/page/:id' })
                    .then(() => {
                        message.success('更新成功');
                        // 此处跳转到当前页面，用于触发DesignPage组件的UNSAFE_componentWillReceiveProps生命周期，才能在此周期中将最新的页面数据通过setstate更新数据，并render页面
                        services.navigation.goto('/design/page/design/' + this.props.params.id);
                    })
                    .catch(errorHandle);
            } else {
                message.error('获取积分商品最新信息失败！');
            }
        } else {
            message.info('没有需要更新的积分商品！');
        }
    };
    getskuListBySkus = async (type, skus) => {
        let res: any = await api.get(
            { type: type, page: 1, per_page: 1000, skus: skus },
            { apiPath: '/products', apiRoot: ENV.API_ROOT }
        );
        return res.result;
    };
    onCancel = () => {
        services.navigation.goBack();
    };
    render() {
        const {
            client,
            params: { id },
        } = this.props;
        const submitProps = {
            onClick: this.onSave,
        };
        const cancelProps = {
            onClick: this.onCancel,
        };
        const updateProps = {
            onClick: this.onUpdate,
        };
        return (
            <DesignPage
                urlId={id}
                client={client}
                loadProfile={this.loadProfile}
                submit={submitProps}
                cancel={cancelProps}
                update={updateProps}
                verbose={true}
                isTemplate={false}
                linkTypes={DESIGN_PAGE_LINK_TYPES_LIST}
                uploadAction={`${ENV.API_ROOT}/images`}
            ></DesignPage>
        );
    }
}
